/**
 * @generated SignedSource<<20b2eb3e8201410c97d8cabc70ae1465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_viewer$data = {
  readonly isMultiItemCart: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionActionBinAndBid_viewer";
};
export type PdpSharedAuctionActionBinAndBid_viewer$key = {
  readonly " $data"?: PdpSharedAuctionActionBinAndBid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_viewer",
  "selections": [
    {
      "alias": "isMultiItemCart",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "30429409b07615b4879d75946a63e3b3";

export default node;
